module.exports = __webpack_public_path__ + "img/download-android.f3f11040.png";